import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSelectDropdownItemStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            gap: 6,
            fontSize: 16,
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center',
            padding: '6px 0px',
            color: 'inherit',
            textDecoration: 'none',

            [theme.breakpoints.up('md')]: {
                padding: '6px 16px'
            }
        },
        clickable: {
            cursor: 'pointer'
        }
    })
);
